import { TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RktButtonDirective } from '@rocketfinancialcorp/rocket-ui/button';
import { ActiveModal } from '@rocketfinancialcorp/rocket-ui/modal';

import { AttentionModalComponent } from '../attention-modal/attention-modal.component';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['confirm-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RktButtonDirective, AttentionModalComponent, TitleCasePipe],
})
export class ConfirmModalComponent {
  confirmType: 'warning' | 'error' | 'success' | 'suspend' | 'resume' = 'error';

  title = 'Attention';

  actionName?: string;

  confirmBtnText?: string;

  displayName?: string;

  customText?: string;

  showCancelButton = true;

  type!: 'Counterparty' | 'TeamMember' | 'FinancialAccount' | 'Transaction' | 'Customer';

  get typeText() {
    switch (this.type) {
      case 'TeamMember':
        return 'Team Member';
      case 'Counterparty':
        return 'Counterparty Account';
      case 'FinancialAccount':
        return 'Financial Account';
      case 'Customer':
        return 'Customer Account';
      default:
        return this.type;
    }
  }

  constructor(public activeModal: ActiveModal) {}
}
